import React, { useState } from "react";

const Signup = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match ❌");
      return;
    }

    setLoading(true);

    try {
      const payload = {
        name: name.trim(),
        email: email.trim(),
        password,
        password_confirmation: confirmPassword,
      };

      const res = await fetch(
        "https://admin.businessunbuzzed.com/api/user/register",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await res.json();
      console.log("Signup Response:", data);

      if (!res.ok || data.status === false) {
        let msg = "Signup failed";
        if (data.errors) {
          msg = Object.values(data.errors).flat().join(", ");
        } else if (data.message) {
          msg = data.message;
        }
        throw new Error(msg);
      }

      // Store token in localStorage if API returns token
      if (data.token) {
        localStorage.setItem("token", data.token);
      }

      // Redirect directly to home page
      window.location.href = "/";
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-left">
          <h2 className="auth-title">Create Account 🚀</h2>
          <p className="auth-subtitle">Join us and get started today</p>

          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Full Name</label>
              <input
                type="text"
                placeholder="Enter full name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Password</label>
              <input
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
            </div>

            <button type="submit" className="btn-custom" disabled={loading}>
              {loading ? "Signing up..." : "Sign Up"}
            </button>
          </form>

          {error && <p style={{ color: "red" }}>{error}</p>}

          <p className="auth-text">
            Already have an account? <a href="/login">Login</a>
          </p>
        </div>

        <div className="auth-right">
          <img
            src="/img/international-business.png"
            alt="Sign Up"
            className="auth-image"
          />
        </div>
      </div>
    </div>
  );
};

export default Signup;
